export const DEFAULT_FORMAT = "MM/DD/YY h:mm a";
